import { QueryCache, QueryClient } from "@tanstack/react-query";

import { isApiError } from "@/api/client";
import { keys } from "@/api/keys";

/** Retry transient failures only — never 4xx responses. */
function shouldRetry(failureCount: number, error: unknown): boolean {
  if (isApiError(error) && error.status >= 400 && error.status < 500) return false;
  return failureCount < 2;
}

/** The API refuses everything until the current Terms are accepted: refresh the session, which shows the dialog. */
function onQueryError(error: unknown): void {
  if (isApiError(error) && error.code === "terms_required") {
    void queryClient.invalidateQueries({ queryKey: keys.session });
  }
}

export const queryClient: QueryClient = new QueryClient({
  queryCache: new QueryCache({ onError: onQueryError }),
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      retry: shouldRetry,
      refetchOnWindowFocus: true,
    },
    mutations: { retry: false, onError: onQueryError },
  },
});
